<template>
  <el-button type="primary" size="mini" icon="el-icon-download" style="margin-right: 10px" @click="downloadExcel">导出汇总表</el-button>
  <!-- <el-button type="info" size="mini" icon="el-icon-download" >下载</el-button> -->
</template>

<script>
import ExportJsonExcel from 'js-export-excel'
export default {
  name: 'ExportExcel',
  props: {
    info: ''
  },
  data() {
    return {}
  },
  computed: {
    errorLogs() {
      // return this.$store.getters.errorLogs
      // this.$store.dispatch('errorLog/clearErrorLog')
    }
  },
  mounted() {},
  methods: {
    downloadExcel() {
      // this.$http.post
      console.log(this.info, 'info')
      const data = this.info ? this.info : '' // 表格数据
      var option = {}
      const dataTable = []
      if (data) {
        for (const i in data) {
          if (data) {
            const obj = {
              月份: data[i].month,
              账号: data[i].company.username,
              真实姓名: data[i].company.name,
              联系方式: data[i].company.contact,
              出勤天数: data[i].attendance,
              缺卡: data[i].missCards,
              外勤: data[i].ops
            }
            dataTable.push(obj)
          }
        }
      }
      option.fileName = '打卡汇总'
      option.datas = [
        {
          sheetData: dataTable,
          sheetName: 'sheet',
          sheetFilter: ['月份', '账号', '真实姓名', '联系方式', '出勤天数', '缺卡', '外勤'],
          sheetHeader: ['月份', '账号', '真实姓名', '联系方式', '出勤天数', '缺卡', '外勤'],
          columnWidths: ['5', '5', '5', '6', '5', '5', '5']
        }
      ]
      var toExcel = new ExportJsonExcel(option)
      toExcel.saveExcel()
    }
  }
}
</script>

<style scoped></style>
